export default __webpack_public_path__ + "static/media/bg_product.f2bf8210.png";